import React, { useContext } from "react";
import _ from "lodash";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import { TranslationContext, StyleTypeContext } from "../../../umbilical_tools";
import { useSelector } from "react-redux";
import { InlineIcon } from "@iconify/react";
import jssVariables from "../../../jss_setup";

const incExcRuleStyles = createUseStyles({
  rule: (props) => ({
    background: "rgba(0, 0, 0, 0) !important",
    color: jssVariables.colors.text.dark,
    ..._.get(props, "customStyles.incExcRule", {}),
  }),
  ruleHeader: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    gridGap: `calc(${jssVariables.normal_gap} / 2)`,
    alignItems: "center",
    fontWeight: "normal",
    ..._.get(props, "customStyles.ruleHeader", {}),
  }),
  description: (props) => ({
    padding: `calc(${jssVariables.normal_gap} / 2)`,
    ..._.get(props, "customStyles.description", {}),
  }),
  icon: (props) => ({
    color: "#1F9C00",
    fontSize: "xx-large",
    ..._.get(props, "customStyles.icon", {}),
  }),
});
const InclusExcl = ({ rule, customStyles, isInclusion }) => {
  const classes = incExcRuleStyles({
    customStyles,
  });
  return (
    <div className={classes.rule}>
      <h5 className={classes.ruleHeader}>
        {isInclusion ? (
          <InlineIcon className={classes.icon} icon="mdi:tick" />
        ) : (
          <InlineIcon
            className={classes.icon}
            icon="ic:outline-plus"
            style={{ color: "#D90F16", transform: "rotate(45deg)" }}
          />
        )}
        {rule}
      </h5>
    </div>
  );
};
InclusExcl.defaultProps = {
  rule: "",
  customStyles: {},
  isInclusion: true,
};
InclusExcl.propTypes = {
  rule: PropTypes.string.isRequired,
  customStyles: PropTypes.object.isRequired,
  isInclusion: PropTypes.bool,
};

const incExcStyles = createUseStyles({
  InclusionsExclusions: (props) => ({
    margin: jssVariables.spacing.section_margin_mobile_small,
    ..._.get(props, "customStyles.InclusionsExclusions", {}),
  }),
  InclusionsExclusionsContr: (props) => ({
    display: "grid",
    gridGap: jssVariables.double_gap,
    gridAutoRows: "max-content",
    padding: jssVariables.spacing.center_padding_mobile_medium,
    ..._.get(props, "customStyles.InclusionsExclusionsContr", {}),
  }),
  list: (props) => ({
    display: "grid",
    gridgap: jssVariables.normal_gap,
    ..._.get(props, "customStyles.list", {}),
  }),
  header: (props) => ({
    fontSize: "x-large",
    fontWeight: "bold",
    textTransform: "capitalize",
    paddingBottom: jssVariables.normal_gap,
    ..._.get(props, "customStyles.header", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    InclusionsExclusionsContr: (props) => ({
      gridTemplateColumns: "repeat(2, 1fr)",
      gridGap: `calc(${jssVariables.normal_gap} * 4)`,
      padding: jssVariables.spacing.center_padding_medium,
      ..._.get(props, "customStyles.InclusionsExclusionsContr.smallscreen", {}),
    }),
    list: (props) => ({
      ..._.get(props, "customStyles.list.smallscreen", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {
    InclusionsExclusionsContr: (props) => ({
      padding: jssVariables.spacing.center_padding_large,
      ..._.get(props, "customStyles.bigscreen.smallscreen", {}),
    }),
  },
});
const InclusionsExclusions = () => {
  const { t } = useContext(TranslationContext);
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const customStyles = cStyler({
    type,
    brand,
    objName: "actDetailsInclusionsExcls",
  });
  const classes = incExcStyles({
    customStyles,
  });

  const { inclusions, exclusions } = useSelector((state) => {
    return {
      inclusions: _.get(state.ActivitySelected, "activity.inclusions", []),
      exclusions: _.get(state.ActivitySelected, "activity.exclusions", []),
    };
  });

  return (
    <div className={classes.InclusionsExclusions}>
      <div className={classes.InclusionsExclusionsContr}>
        {inclusions.length ? (
          <div className={classes.rules}>
            <div className={classes.header}>{t("inclusions")}</div>
            <div className={classes.list}>
              {inclusions
                .filter((rule) => rule)
                .map((rule, idx) => (
                  <InclusExcl
                    key={idx}
                    rule={rule}
                    customStyles={customStyles}
                    isInclusion={true}
                  />
                ))}
            </div>
          </div>
        ) : null}
        {exclusions.length ? (
          <div className={classes.rules}>
            <div className={classes.header}>{t("exclusions")}</div>
            <div className={classes.list}>
              {exclusions
                .filter((rule) => rule)
                .map((rule, idx) => (
                  <InclusExcl
                    key={idx}
                    rule={rule}
                    customStyles={customStyles}
                    isInclusion={false}
                  />
                ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
InclusionsExclusions.defaultProps = {
  details: {},
  customStyles: {},
};
InclusionsExclusions.propTypes = {
  details: PropTypes.object.isRequired,
  customStyles: PropTypes.object.isRequired,
};
export default InclusionsExclusions;
